import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { ADD_PARKER_FORM_STEPS } from "../../../../../enums/Enums";
import Strings from "../../../../../resources/Strings";
import EllipseButton from "../../../Buttons/EllipseButton/EllipseButton";
import classes from "../WizardForm.module.css";
import { SiteOperationsEntity } from "../../../../../entities/ServicesEntities/UserEntities/SiteOperationsEntity";
import UserTypeStep from "../Steps/UserTypeStep";
import * as userSiteActionsService from "../../../../../services/ActionsService/UserSiteActionsService";
import store from "../../../../../redux/Store";
import {
  showErrorMessage,
  showUpdateSuccessMessage,
} from "../../../../../utils/MessagesUtils";
import { commonActions } from "../../../../../redux/reducers/CommonReducer";
import { refreshSitesAndScopes } from "../../../../../utils/MenuUtils";

const AddFacilityForm = (props) => {
  const currentSites = useSelector((state) => state.user.selectedSites);
  const selectedScope = useSelector((state) => state.user?.selectedScope);
  const parkerSelectionModel = useSelector((state) => state.user.parkerSelectionModel);      
  const currentUserData = parkerSelectionModel || props;

  const [formData, setFormData] = useState({
    userType: "",
    site: "",
    userSites: currentUserData?.utronUser?.userSites,
    userToUserTypes: currentUserData?.utronUser?.userToUserTypes,
    isEditMode: true
  });

  const [stateData, setStateData] = useState({
    currentStep: ADD_PARKER_FORM_STEPS.USER_TYPE,
    totalSteps: 1,
    isCurrentStepValid: false,
  });

  const handleChange = (newProp) => {
    setFormData({ ...formData, ...newProp });
  };

  const handleCurrentStepValidity = (hasError) => {
    setStateData({ ...stateData, isCurrentStepValid: !hasError });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setFormData({ ...formData, ["isStepSubmitted"]: true });
    const { userType, site } = formData;

    if (stateData.isCurrentStepValid) {
      const siteOperationsEntity = new SiteOperationsEntity(
        null,
        site,
        props?.utronUser?.id,
        userType
      );

      userSiteActionsService
        .updateUserToSite(siteOperationsEntity, true, false)
        .then((response) => {
          // prevents the sideModal to be reopened (when its the one and only step) 
          // (see: UserTypeStep, useEffect props.currentStep)
          stateData.currentStep++; 
          store.dispatch(commonActions.closeSideModal());
          if (response.data.isSuccess) {
            refreshSitesAndScopes(response.data.entity, props?.utronUser?.id)
              .then(() => {                
                store.dispatch(commonActions.setIsShowLoadingSpinner(false));
                showUpdateSuccessMessage();
              })
              .catch((error) => {
                console.error('Error refreshing after facility add:', error);
              });
          } else {
            showErrorMessage(response.data?.error);
          }
        });
    }
  };
  return (
    <form name="AddFacilityForm" onSubmit={handleSubmit}>
      <div className={classes.formContainer}>
        <UserTypeStep
          isEditMode={props.isEditMode}
          currentStep={stateData.currentStep}
          handleChange={handleChange}
          handleCurrentStepValidity={handleCurrentStepValidity}
          {...formData}
        />
      </div>
      <div className={classes.next}>
        <EllipseButton disabled={currentSites?.length === 0} type="submit">{Strings.SAVE_CHANGES}</EllipseButton>
      </div>
    </form>
  );
};

export default AddFacilityForm;
